export interface CommunityLink {
    /** The id of the community link */
    community_link_id: number;
    /** The community link */
    targets: Target[];
    /** The comunity link regexes */
    regexes: string[];
}

export interface Target {
    /** Language */
    language: string;
    /** The url of the community link */
    url: string;
}

/** Default community link id (this is always returned by api to have a fallback) */
export const DefaultCommunityLinkId: number = 1;
/** Fallback language for non-NL users */
export const FallBackLanguage: string = "en-US";
